module.exports = __webpack_public_path__ + "static/img/duom06.cac994c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jingmai/duom06.png
// module id = 982
// module chunks = 0